import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from 'src/app/core/services/data.service';
import { ExportFiles } from '../models/export-files.model';

@Injectable({
    providedIn: 'root'
})
export class ExportFileService {

    constructor(private readonly _dataService: DataService) {
    }

    getExportDocFiles = (loanId: number): Observable<ExportFiles[]> => {
        return this._dataService.get(`api/File/GetFileForExport/${loanId}`);
    }
}
